export const SIGNIN_TITLE = 'Sign in';
export const SIGNUP_TITLE = 'Create account';
export const CONSENTS_TITLE = 'Legal policies';
export const CHOOSE_ACCOUNT_TYPE = 'Choose account type';
export const FORGOT_UN_PW_TITLE = 'Trouble signing in?';
export const UNVERIFIED_RECAPTCHA = 'Multifactor authentication';
export const FORGOT_UN_PW_TITLE_LEGACY = 'Forgot your username or password?';
export const RESET_PW_TITLE = 'Change password';
export const RESET_PW_TITLE_LEGACY = 'Reset your password';
export const AUO_WELCOME_TITLE = 'Welcome';
export const CREATE_PW_TITLE = 'Create password';
export const ADD_HOME_COUNTRY = 'Additional information';
export const ADD_MOBILE_PHONE = 'Add mobile phone';
export const VERIFY_MOBILE_PHONE = 'Check your phone';
export const VERIFY_EMAIL = 'Check your email';
export const SECURITY_QUESTIONS = 'Security questions';
export const ACCT_MGMT_TITLE = 'Account management';
export const SIGNIN_CODE_TITLE = 'Sign in with code';
export const VERIFY_CODE_TITLE = 'Enter code';
export const CODE_HELP_TITLE = "Didn't receive the code?";
